// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-jZf","col":"styles_col__1VKVv"};